import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { fuseAnimations } from '../../../../../../../../../../core/animations';
import * as _ from 'lodash';
import { MatDialogRef, MatDialog } from '@angular/material';

// Local component
import { ToastComponent } from '../../../../../../../common/toast.component';
import { FuseConfirmDialogComponent } from '../../../../../../../../../../core/components/confirm-dialog/confirm-dialog.component';

// Service file
import { SideNavService } from '../../../../sidenav.service';

// Model & Util
import { FileBrowseEvent, UploadResponse, CreateTestimonial, FetchTestimonials} from '../../../../../../../models/index';
import { checkoutFields, apiCalls, toastMsg, displayValues, site } from '../../../../../../../utils/index';

@Component({
  selector: 'spekwo-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class TestimonialsComponent implements OnInit {

  checkoutFields = checkoutFields;
  toastMsg = toastMsg;
  displayValues = displayValues;
  apiCalls = apiCalls;

  allBrowsedFile: FileBrowseEvent[] = [];
  quotes: string = '';
  isLogoUpload: boolean = false;

  lastLogoId: number;
  allTestimonialDetail = [];
  imgviewLoader: boolean = false;
  deletArray = [];

  months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  @ViewChild('testimonials') testimonials: ElementRef;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;

  constructor(
    private _sideNavService: SideNavService,
    private _toastComponent: ToastComponent,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.getTestimonialDatas();

  }

  getTestimonialDatas() {
    this.imgviewLoader = true;
    this._sideNavService
      .fetchAllTestimonial()
      .then((alLogos: FetchTestimonials) => {
        this.allTestimonialDetail = [];
        let res = alLogos && alLogos.data && alLogos.data.allTestimonials.nodes;
        this.lastLogoId = res.length > 0 ? res[0].id : 0;
        _.each(res, data => {
          var testimonialData = {};
          testimonialData['id'] = data.id;
          testimonialData['nodeId'] = data.nodeId;
          testimonialData['createdat'] = data.createdat;
          testimonialData['personpicurl'] = data.personpicurl;
          testimonialData['quotes'] = data.quotes;
          testimonialData["month"] = this.months[new Date(data.createdat).getMonth()];
          testimonialData["year"] = this.months[new Date(data.createdat).getFullYear()];
          testimonialData['imageUrl'] = site.apiHost + data.personpicurl;
          testimonialData['checked'] = false;
          this.allTestimonialDetail.push(testimonialData);
        });
        this.imgviewLoader = false;
      })
      .catch(() => {
        this.imgviewLoader = false;
      });
  }

  //  Browse files

  onFileChange(event: any) {
    if (event && event.target.files.length > 0) {
      this.allBrowsedFile = event.target.files;
    }
  }

  //  Clear selected files
  clearFile() {
    this.testimonials.nativeElement.value = '';
    this.allBrowsedFile = [];
  }

  //  Submit selected files to backend
  async onSubmitFile() {

    this.isLogoUpload = true;
    var imageUploaded = this.allBrowsedFile[0];
    this.lastLogoId = this.lastLogoId + 1;

    let fileName1 = this.lastLogoId + '_' + imageUploaded.name;
    let fileName = this.apiCalls.uploadTestimonialFolder + '/' + fileName1;

    // Store in db
    await this._sideNavService.CreateTestimonialOnDb(fileName, this.quotes)
      .then(async (createRes: CreateTestimonial) => {
        // let fileName = createRes && createRes.data.CreateTestimonial.testimonial.id + '_' + data.name;
        await this._sideNavService.fileUpload(imageUploaded, fileName1, 'testimonial')
          .then(async (res: UploadResponse) => {

            if (res.status == this.checkoutFields.uploadCompanyLogoSuccess) {
              this.allBrowsedFile = [];
              this.quotes = '',
                this.isLogoUpload = false;
              this._toastComponent.showToast(this.toastMsg.uploadCompanyLogoSuccess);
              this.ngOnInit();
            } else {
              this._toastComponent.showToast(this.toastMsg.uploadCompanyLogoFailed);
            }

          })
          .catch(() => {
            this.isLogoUpload = false;
          });
      });

  }

  //Onselect function of checkbox
  onChangeCheck(event, testimonialId) {
    if (event.checked) {
      this.deletArray.push(testimonialId);
    }
    if (!event.checked) {
      const index: number = this.deletArray.indexOf(testimonialId);
      if (index !== -1) {
        this.deletArray.splice(index, 1);
      }
    }
  }

  //Delete functionality
  onDeleteAction() {
    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: false
    });

    this.confirmDialogRef.componentInstance.confirmMessage = this.displayValues.manageRef.deleteConfirm;
    this.confirmDialogRef.componentInstance.confirmHead = this.displayValues.manageRef.deleteHead;
    this.confirmDialogRef.componentInstance.confirmOkText = this.displayValues.manageRef.deleteOk;
    this.confirmDialogRef.componentInstance.confirmCancelText = this.displayValues.manageRef.deleteCancel;

    this.confirmDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.imgviewLoader = true;
        var index = 0;
        _.each(this.deletArray, (data) => {
          this._sideNavService.
            deleteSelectedTestimonialData(data).then((res) => {
              ++index;
              if (res) {
                this._toastComponent.showToast(this.toastMsg.deleteScheSuccess);
               }
              if (index == this.deletArray.length) {
                this.deletArray = [];
                this.getTestimonialDatas();
              }
            });
        });
      }
      this.confirmDialogRef = null;
    });

  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/manage-references/testimonials/testimonials.component.ts